import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://pgqzjuqixyssienjwzkk.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_GSJVoXk_LiMp46CuHCumPA_X05vJ4Wb';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
